

import ConfirmationModal
    from "../../components/ConfirmationModal";

import useConfirmation
    from "../../../hooks/useConfirmation";

export function useUtilisation({
    db,
    globalState,
    dispatch,
    workplaces,
    clickStates,
    setClickStates,
    setSubmitted,
    setShowSubmittedLabel,
    setShowSubmitButton
}) {

    /**************************************************************************
     * CONFIRMATION HOOK
     *************************************************************************/

    const {
        confirm,
        modalProps,
        handleModalConfirm,
        handleModalCancel
    } = useConfirmation();
	
	
	function getRecordDate(timestamp) {

	    if (!timestamp) {

	        return null;
	    }

	    if (typeof timestamp === "string") {

	        return timestamp.split("T")[0];
	    }

	    if (timestamp instanceof Date) {

	        return timestamp
	            .toISOString()
	            .split("T")[0];
	    }

	    return null;
	}

    /**************************************************************************
     * SAVE UTILISATION
     *************************************************************************/

    async function saveUtilisation(
        desk,
        state,
        selectedActivityId = null,
        capacityUsed = 0
    ) {

        const hour =
            Number(
                globalState.state.observationHour ??
                new Date().getHours()
            );
			
			

        const now =
            new Date();

        const today =
            now
                .toISOString()
                .split("T")[0];

        const existing =
            await db.utilisation
                .where("floorId")
                .equals(
                    globalState.state.selectedFloor.id
                )
                .and(function (r) {

                    const recordDate =
                       getRecordDate(r.timestamp);

                    return (
                        recordDate === today &&
                        r.spaceId === desk.id &&
                        r.observationHour === hour
                    );
                })
                .first();

        const row = {
            spaceId: desk.id,
            floorId:
                globalState.state.selectedFloor.id,
            timestamp: now.toISOString(),
            observationHour: hour,
            observationMinute: 0,
            capacityUsed: capacityUsed,
            activityId:
                selectedActivityId || null,
            occupiedVacantSol: state,
            processed: false
        };

        if (existing) {

            row.id = existing.id;
        }

        await db.utilisation.put(row);
    }

    /**************************************************************************
     * HANDLE SUBMIT
     *************************************************************************/

    async function handleSubmit(floorCount) {
		
        const floorId =
            globalState.state.selectedFloor.id;

        const hour =
            Number(
                globalState.state.observationHour ??
                new Date().getHours()
            );

        const today =
            new Date()
                .toISOString()
                .split("T")[0];

        const existing =
            await db.utilisation
                .where("floorId")
                .equals(floorId)
				.and(function (r) {

				    const d =
				        getRecordDate(r.timestamp);

				    return (
				        d === today &&
				        Number(r.observationHour) === hour
				    );
				})
                .toArray();
				
				const toUpsert =
				    workplaces.map(function (w) {

				        const existingRow =
				            existing.find(function (r) {

				                return r.spaceId === w.id;
				            });

				        return {
				            id:
				                existingRow
				                    ? existingRow.id
				                    : undefined,

				            spaceId: w.id,

				            floorId: floorId,

				            timestamp:
				                new Date().toISOString(),

				            observationHour: hour,

				            observationMinute: 0,

				            capacityUsed:
				                w.capacity || 0,

				            activityId:
				                w.selectedActivityId || null,

				            occupiedVacantSol:
				                clickStates[w.id] || 0,

				            processed: true
				        };
				    });
       

					await db.utilisation.bulkPut(
					    toUpsert
					);

        await confirm({
            title: "Hour Submitted",
            message:
                "Survey hour submitted successfully.",
            confirmText: "OK",
            hideCancel: true,
            confirmColor: "#22c55e"
        });

        if (floorCount > 1) {

            await confirm({
                title: "Additional Floors",
                message:
                    "You may still have other floors to submit.",
                confirmText: "OK",
                hideCancel: true,
                confirmColor: "#f59e0b"
            });
        }
		
        setSubmitted(true);

        setShowSubmittedLabel(true);

        setShowSubmitButton(false);
    }

    /**************************************************************************
     * RETURN
     *************************************************************************/

    return {
        saveUtilisation,
        handleSubmit,

        confirmModal: (
            <ConfirmationModal
                {...modalProps}
                onConfirm={handleModalConfirm}
                onCancel={handleModalCancel}
            />
        )
    };
}